import * as ApiHelper from "~/common/utils/ApiHelper";
import { downloadBlobFromResponse } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export interface ProductConfiguratorPDFData {
  designation: string;
  description: string;
  manufacturerLogoUrl: string;
  brandLogoUrl: string;
  imageUrl: string;
  steps: Step[];
}

interface Step {
  title: string;
  substepData: SubstepData[];
}

interface SubstepData {
  name: string;
  headerRow?: string[];
  dataRows: DataRowItem[][];
}

interface DataRowItem {
  value: string;
  standard: boolean;
}

const baseUrl = resolveApiUrl("/configurator/{productcode}/download/datasheet");

export async function apiGenerateDatasheet(productCode: string, data: ProductConfiguratorPDFData) {
  const url = baseUrl.replace("{productcode}", productCode);

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`Failed to generate datasheet: ${response.statusText}`);
  }

  downloadBlobFromResponse(response);
}
